<div class="d-flex justify-content-around flex-wrap mt-4">
    <div id="chartContainer" class="row col-12">
        <div class="h-100">
            <p class="text-center f18 dirI"> {{ mdl_Search.get('title')?.value }} </p>
            <canvas id="myChart"></canvas>
        </div>
    </div>
</div>